export default "__VITE_ASSET__D$qGeVsn__"